import { createAction } from 'redux-act'
import API from 'api'

export const request = createAction('events/request')
export const receive = createAction('events/receive')
export const receiveDates = createAction('events/receiveDates')
export const setCurrentEvent = createAction('events/setCurrentEvent')
import {
  updateEventLanguages,
  updateEventLanguage,
} from 'actions/languages'

export const fetch = (id, locale, places, ignoreLanguages = false, extras = {}) => (dispatch, getState) => {
  dispatch(request({ id, locale }))
  updateEventLanguage(locale)

  return API.event(id, locale, places, extras, getState().ui.locale)
    .then(event => {
      dispatch(updateEventLanguages(event.languages))
      return dispatch(receive({
        id,
        locale,
        event,
        ignoreLanguages,
      }))
    })
}

export const setCurrentEventAction = (id, locale, places, ignoreLanguages) => (dispatch, getState) => {
  dispatch(setCurrentEvent({ id }))

  return fetch(id, locale, places, ignoreLanguages)(dispatch, getState)
}
